import type React from "react";
import { motion } from "framer-motion";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { Divider, Monogram } from "./Ornament";

const Footer: React.FC = () => {
  return (
    <footer className="mt-20 pb-10 px-6">
      <div className="max-w-6xl mx-auto">
        <Divider />

        <div className="mt-10 flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
          <div className="flex items-center gap-4">
            <Monogram className="text-2xl" />
            <div className="flex flex-col leading-tight">
              <span className="font-display text-xl text-[color:var(--claret-deep)]">
                Moyle Manor
              </span>
              <span className="u-label mt-1">Beaumont · Est. 1926</span>
            </div>
          </div>

          <p className="u-label text-[color:var(--ink-soft)]">
            © {new Date().getFullYear()} · All rights reserved
          </p>

          <div className="flex items-center gap-4">
            <motion.a
              href="https://www.facebook.com/profile.php?id=61581622530508#"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.95 }}
              aria-label="Facebook"
              className="w-10 h-10 grid place-items-center rounded-full border border-[color:var(--gilt-hairline)] text-[color:var(--claret)] hover:bg-[color:var(--claret)] hover:text-[color:var(--parchment)] transition-colors duration-500"
            >
              <FaFacebookF size={13} />
            </motion.a>
            <motion.a
              href="https://www.instagram.com/moyle.manor"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.95 }}
              aria-label="Instagram"
              className="w-10 h-10 grid place-items-center rounded-full border border-[color:var(--gilt-hairline)] text-[color:var(--claret)] hover:bg-[color:var(--claret)] hover:text-[color:var(--parchment)] transition-colors duration-500"
            >
              <FaInstagram size={15} />
            </motion.a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
